import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { VLink } from '../../other/vLink';

const HeroContainer = styled.div<{ backgroundImage: string }>(() => `
  background-color: transparent;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 600px;
  padding: 35% 32px 0px 32px;

  @media (min-width: 1080px) {
    padding: 0 64px;
  }

  @media (min-width: 768px) {
    height: 655px;
  }
`);

const Animated = styled.div`
  animation: i .8s .4s cubic-bezier(.41,.01,.27,1) both;

  @keyframes i {
    0% {
        opacity: 0;
        -webkit-transform: translateY(3.125rem);
        transform: translateY(3.125rem)
    }

    to {
        opacity: 1;
        -webkit-transform: none;
        transform: none
    }
}
`;

const Grow = styled.div`
  animation: line-grow 0.8s forwards;
  animation-delay: 0.8s;

  @keyframes line-grow {
     from { width: 0px; }
     to { width: 48px; }
  }
`;

const Button = ({ label, link }: { label: string; link: string }) => {
  const className = `text-black uppercase inline-block py-3 px-5 md:px-8 mr-4 bg-transparent text-md md:text-xl border border-stone mb-5`;
  return <VLink className={className} to={link}>{label}</VLink>;
};

interface HeroProps {
  headline: string;
  subtitle: string;
  imageRow1: Asset[];
  image: Asset;
  backgroundImage: Asset;
  slanted: boolean;
  button1Label?: string;
  button2Label?: string;
  button1Link?: string;
  button2Link?: string;
}

export const HeroSecondary: React.FC<HeroProps> = ({
  headline,
  subtitle,
  image,
  button1Label,
  button2Label,
  button1Link,
  button2Link,
}) => {
  return (
    <HeroContainer className="relative flex flex-col justify-end text-black border-b sm:items-end sm:flex-row border-stone">
      <div className="order-last text-left sm:flex-1 sm:order-first">
        <Animated>
          <h1 className="max-w-3xl mb-5 text-4xl leading-tight font-playfair">{headline}</h1>
          <p className="max-w-3xl mb-6 text-lg mt -4">{subtitle}</p>
          <Grow className="w-0 h-6" style={{borderTop: '6px solid #46ff46'}} />
          <div className="mt-6">
            {button1Label &&
              <Button label={button1Label} link={button1Link ? button1Link : '#'} />
            }
            {button2Label &&
              <Button label={button2Label} link={button2Link ? button2Link : '#'} />
            }
          </div>
        </Animated>
      </div>
      <div className={'sm:flex-1 order-first sm:order-last'}>
        {image && <img src={image.url} alt={image.name} className={'mx-auto sm:max-w-lg'} />}
      </div>
    </HeroContainer>
  );
};
